import React, { Component } from "react";
import MUIDataTable from "mui-datatables";
import axios from 'axios';
import Fab from '@material-ui/core/Fab';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import ViewIcon from '@material-ui/icons/Visibility';
import CustomToolbarSelect from "./CustomToolbarSelect";
import { Link, BrowserRouter as Router, Route } from "react-router-dom";
import CircularProgress from '@material-ui/core/CircularProgress';
import Chip from '@material-ui/core/Chip';

import IconButton from '@material-ui/core/IconButton';
import Tooltip from "@material-ui/core/Tooltip";
import AddIcon from "@material-ui/icons/Add";
import Button from '@material-ui/core/Button';
  //import { Store } from "../../flux";
import api from '../../common/api';

class PolicyVehicles extends React.Component {

   constructor() {
      super();

      this.state = {
        data: '',
        param:'',
        policy_id: '',
        policy_name: '',
        contract_id:'',
        isLoaded: false,
        vehicles:[]
      }
    }

    componentDidMount() {
      const param = this.getParams().query
      this.setState({policy_id: param});

      if (param !== 0)
      this.getContract(param).then(result => this.setState({
           contract_id:  result ? (result.contract) ? result.contract.id : 0 : 0 
      }))

    }
   
   getParams(location) {
      const searchParams = new URLSearchParams(window.location.search);
      return {
        query: searchParams.get("idPolicy")
      };
    } 

   getContract = (policy_id) => {
          const token =localStorage.getItem('userToken')

         return axios
                  .get(api.policy().get(policy_id),{ headers: {"Authorization" : `Bearer ${token}`} })
                  .then(res => {
//                    this.getVehicles(res.data.contract.id)
                    if (res.data.contract){
                      this.getVehicles(res.data.contract.id)
                    } else {
                      this.getVehicles(0)
                    }
                    this.setState({policy_name: res.data.name})
                    return res.data
                  })
                  .catch(err =>{console.log(err)
                  })

        }

  getVehicles = (contract_id) => {
    const token =localStorage.getItem('userToken')

    if (contract_id !== 0){
       return axios
                .get(api.contract().get(contract_id),{ headers: {"Authorization" : `Bearer ${token}`} })
                .then(res => {
                  this.setState({isLoaded: true, vehicles: res.data[0].vehicles})
                })
                .catch(err =>{console.log(err)
                })

    } else {
       return axios
                .get(api.vehicles().indexAc(),{ headers: {"Authorization" : `Bearer ${token}`} })
                .then(res => {
                  this.setState({isLoaded: true, vehicles: res.data})
                })
                .catch(err =>{console.log(err)
                })

    }
  }


  render(){
     const policy_id = this.state.policy_id;
     const policy_name = this.state.policy_name
     const columns = [
     {
      name: "id",
      label: "Id",
      options: {
       filter: false,
       sort: true,
      }
     },
     {
      name: "plate",
      label: "Patente",
      options: {
       filter: true,
       filterType: "textField",
       sort: true,
      }
     },
     {
      name: "description",
      label: "Descripción",
      options: {
       filter: true,
       filterType: "textField",
       sort: true,
       customBodyRender: (value, tableMeta, updateValue) => {
          return (
            tableMeta.rowData[5] + ' ' + tableMeta.rowData[6] + ' ' + tableMeta.rowData[7]
          )
        }
      }
     }
     ,
     {
      name: "policy.name",
      label: "Nombre de la política",
      options: {
       filter: true,
       filterType: "textField",
       sort: true,
      }
     }
     ,
     {
      name: "policy_id",
      label: "Asignado a esta política",
      options: {
       filter: true,
       sort: true,
        filterOptions: {
                    names: ['Asignado a esta política', 'Asignado a otras políticas'],
                    logic(policy_select_id, filterVal) {
                      const show =
                        (filterVal.indexOf('Asignado a esta política') >= 0 && parseInt(policy_select_id) == parseInt(policy_id)) ||
                        (filterVal.indexOf('Asignado a otras políticas') >= 0 && parseInt(policy_select_id) != parseInt(policy_id));
                      return !show;
                    },
                  },
       customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Chip
             label={parseInt(value) === parseInt(policy_id) ? "Si" : "No"} 
             color={parseInt(value) === parseInt(policy_id) ? "primary" : "secondary"}
            />
          );         
       }
      }
     },
     {
      name: "version.variation.brand.name",
      label: "Marca",
      options: {
       filter: false,
       sort: false,
       display: false,
      }
     },
     {
      name: "version.variation.dnrpa_description",
      label: "Modelo",
      options: {
       filter: false,
       sort: false,
       display: false,
      }
     },
     {
      name: "version.name",
      label: "version",
      options: {
       filter: false,
       sort: false,
       display: false,
      }
     }

    ];

  const headerNames = [
    {
      name: 'id',
      download: true,
    },
    {
      name: 'plate',
      download: true,
    },
    {
      name: 'description',
      download: true,
    },
    {
      name: 'policy_id',
      download: true,
    }
  ];
  const footerNames = [];
  const options = {
    download: true,
    downloadOptions:{filename: `Lista de Vehículos ${this.state.policy_name}.csv`},
    onDownload: (buildHead, buildBody, columns, data) =>
      buildHead(headerNames) +
      buildBody(
        data.concat({
          index: Object.values(this.state.vehicles).length,
          data: footerNames,
        }),
    ),      
    print:false,
    responsive: 'stacked',
    selectableRowsOnClick: true,
    rowsPerPage: 10,
    customToolbarSelect: (selectedRows, displayData, setSelectedRows) => (
      <CustomToolbarSelect selectedRows={selectedRows} displayData={displayData} setSelectedRows={setSelectedRows} policyId={this.state.policy_id} vehicles={this.state.vehicles}/>
    ),
    textLabels: {
          toolbar: {
            search: "Buscar",
            viewColumns: "Ver columnas",
            filterTable: "Filtros",   
            downloadCsv: "Exportar a CSV"        
          },
          body: {
              noMatch: this.state.isLoaded ?
                  'No hay resultados' :
                  <CircularProgress />,
          },
          selectedRows: {
            text: "fila(s) seleccionadas"
          },
          viewColumns: {
            title: "Ver columnas",
          },
          pagination: {
            next: "Siguiente",
            previous: "Anteior",
            rowsPerPage: "Cantidad por página:",
            displayRows: "de",      
          },
          filter: {
            all: "Todos",
            title: "Filtros",
            reset: "Limpiar"
          }
      }
  };

   return(
    <div>
      <MUIDataTable
        title={`Lista de Vehículos ${this.state.policy_name}`}
        data={Object.values(this.state.vehicles)}
        columns={columns}
        options={options}
       />
       <div style={{textAlign: "right"}}>
         <Button variant="contained" className="mt-3 ml-1 mr-1" color="secondary" href={"/policies?idContract="+this.state.contract_id}>
            Volver
        </Button>
      </div>
    </div>
    );
  }

}

export default PolicyVehicles;   